import {
  SR_API_ACTION_JOIN_SUNROOM_CLUB,
} from 'api/actionTypes';

import analytics from 'client/analytics';
import {
  ANALYTICS_EVENT_SUNROOM_CLUB_PAID,
} from 'client/analytics/eventList';

export default async function joinSunroomClub({ state, apiClient }, { source }) {
  await apiClient.postWithState({
    action: SR_API_ACTION_JOIN_SUNROOM_CLUB,
    state: state,
    payload: {
      source,
    },
    onSuccess(updatedUserRoles) {
      state.set(['currentUser', 'roles'], updatedUserRoles);
      analytics.track(ANALYTICS_EVENT_SUNROOM_CLUB_PAID);
    },
    onError(error) {
      throw error;
    },
  });
}
